module.exports = __webpack_public_path__ + "static/media/19.51c5d3ba.svg";